(function () {
  if (window.collectionDetailsModalReady) return;
  window.collectionDetailsModalReady = true;

  var activeModal = null;
  var activeTrigger = null;

  document.querySelectorAll('[data-collection-details-open]').forEach(function (trigger) {
    var section = trigger.closest('.t4s-custom-liquid');
    var description = section && section.querySelector('.collection-description');
    if (description) description.appendChild(trigger);
  });

  function openModal(trigger) {
    var modalId = trigger.getAttribute('aria-controls');
    var modal = modalId && document.getElementById(modalId);
    if (!modal) return;

    activeModal = modal;
    activeTrigger = trigger;
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('is-collection-details-open');

    var dialog = modal.querySelector('[data-collection-details-dialog]');
    if (dialog) window.requestAnimationFrame(function () { dialog.focus(); });
  }

  function closeModal() {
    if (!activeModal) return;

    activeModal.hidden = true;
    activeModal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('is-collection-details-open');

    if (activeTrigger && document.contains(activeTrigger)) activeTrigger.focus();
    activeModal = null;
    activeTrigger = null;
  }

  document.addEventListener('click', function (event) {
    var openButton = event.target.closest('[data-collection-details-open]');
    if (openButton) {
      event.preventDefault();
      openModal(openButton);
      return;
    }

    if (activeModal && event.target.closest('[data-collection-details-close]')) {
      event.preventDefault();
      closeModal();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && activeModal) closeModal();
  });
})();
